import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CanActivateAccess, CanActivateEmailVerification, CanActivateResetPassword } from '@core';

import { AccessPage } from './access.page';
import { AccessForgotPasswordPage } from './forgot-password/forgot-password.page';
import { AccessLoginPage } from './login/login.page';
import { AccessResetPasswordPage } from './reset-password/reset-password.page';
import { AccessSignupPage } from './signup/signup.page';
import { AccessVerifyEmailPage } from './verify-email/verify-email.page';


const routes: Routes = [
  {
    path: '',
    component: AccessPage,
    canActivateChild: [CanActivateAccess],
    children: [
      {
        path: '',
        component: AccessLoginPage
      },
      {
        path: 'signup',
        component: AccessSignupPage
      },
      {
        path: 'forgot-password',
        component: AccessForgotPasswordPage
      },
      {
        path: 'reset-password/:token',
        canActivate: [CanActivateResetPassword],
        component: AccessResetPasswordPage
      },
      {
        path: 'verify/:token',
        canActivate: [CanActivateEmailVerification],
        component: AccessVerifyEmailPage
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AccessRoutingModule {}
